// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1DZ6U","info":"UpdateTermsInfo_info__2gAKn"};